<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('selectionInfo') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/selection/' + this.$route.params.selectionId">
                        {{ data.name }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }} detail</li>
            </ol>
        </nav>
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
            <div class="mb-3 col-md-4">
                <label class="form-label" for="selectionMethod" required>{{ $t('selectionMethod') }}</label>
                <select v-model="data.selectionMethod" class="form-select">
                    <option value="">{{ $t('select')}} </option>
                    <option value="budget">{{ $t('budget')}} </option>
                </select>
            </div>
            <div class="mb-3 col-md-4">
                <label class="form-label" for="coreBenefitMethod" required>{{ $t('coreBenefitMethod') }}</label>
                <select v-model="data.coreBenefitMethod" class="form-select">
                    <option value="significant">{{ $t('significantNumber')}} </option>
                    <option value="performance">{{ $t('performance')}} </option>
                </select>
            </div>
            <div class="mb-3 col-md-12">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description" >
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-2">
                <input class="form-check-input" v-model="data.mandatoryVariants" type="checkbox" id="mandatoryVariants">
                <label class="form-check-label ps-2"  for="mandatoryVariants">
                    {{ $t('mandatoryVariants') }}
                </label>
            </div>
            <div class="col-3">
                <input class="form-check-input" v-model="data.allowBreakLifecycleVariants" type="checkbox" id="allowBreakLifecycleVariants">
                <label class="form-check-label ps-2"  for="allowBreakLifecycleVariants">
                    {{ $t('allowBreakLifecycleVariants') }}
                </label>
            </div>
            <div class="col-3">
                <input class="form-check-input" v-model="data.allowNotFirstVariants" type="checkbox" id="allowNotFirstVariants">
                <label class="form-check-label ps-2"  for="allowNotFirstVariants">
                    {{ $t('allowNotFirstVariants') }}
                </label>
            </div>
        </div>
        <div class="d-grid gap-2 d-md-flex">
            <template v-if="isUserAdmin">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
                <button type="button" class="btn btn-danger" @click="showSelectionDeleteModal = true">{{ $t('delete') }}</button>
            </template>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}` })">{{ $t('back') }}</button>
        </div>
        <SelectionDeleteModal v-if="showSelectionDeleteModal" @reload="$router.push({ path: `/modeling/${this.$route.params.id}` })" @closeDeleteDialog="showSelectionDeleteModal = false"/>
    </div>
</template>

<script>
import ModelingApi from '../../api/server/modeling';
import AnalysisApi from '../../api/server/analysis';
import SelectionApi from "../../api/server/selection";
import CheckIfUserIsAdmin from '../../authCache';
import SelectionDeleteModal from "./SelectionDeleteModal.vue";

export default {
    name: "selectioninfo",
    watch: {
        $route: "requestData",
    },
    components: {
        SelectionDeleteModal
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsAdmin();
            
            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            var modelingResultList = await AnalysisApi.analysisList(this.$route.params.id);
            for (var i in modelingResultList) {
                var result = modelingResultList[i];
                if(result.selectionId == this.$route.params.selectionId) {
                    this.foundSelections.push({ 
                        resultId: result.id,
                        name: "Modeling Result"
                    });
                }
            }
            
            var selectionId = this.$route.params.selectionId;
            var data = await SelectionApi.selectionDetail(this.$route.params.id, selectionId);
            this.data = data;
            if(data.selectionGroup?.length > 0 || data.selectionLimit?.length > 0 || data.selectionPackage.length > 0) {
                this.selectionNotEmpty = true;
            }

            this.pending = false;
        },
        async onSubmit() {
            try {
                if(this.data.name.length > 0) {
                    await SelectionApi.selectionUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } else {
                    this.showEmptyNameError();
                }
            } catch {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'selectionUpdated',
            type: 'success'
        },
        showError: {
            title: 'error',
            message: 'selectionErrorUpdate',
            type: 'error'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionMethod: ""
            },
            showSelectionDeleteModal: false,
            pending: true,
            modelingName: "",
            isUserAdmin: false,
            foundSelections: [],
            selectionNotEmpty: false,
        }
    }
};
</script>